"use strict";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "loading" ];

  connect() {
    const PDFJS = window["pdfjs-dist/build/pdf"];
    const url = this.element.dataset.url;
    let thePdf = null;
    const scale = 1;

    const viewer = this.element;

    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("tw-hidden");
    }

    PDFJS.GlobalWorkerOptions.workerSrc =
      "https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js";

    PDFJS.getDocument(url).promise.then((pdf) => {
      if (this.hasLoadingTarget) {
        this.loadingTarget.classList.add("tw-hidden");
      }
      thePdf = pdf;
      for (let page = 1; page <= pdf.numPages; page++) {
        const canvas = document.createElement("canvas");
        canvas.className = "pdf-page-canvas";
        viewer.appendChild(canvas);
        renderPage(page, canvas);
      }
    });

    function renderPage(pageNumber, canvas) {
      thePdf.getPage(pageNumber).then(function(page) {
        const viewport = page.getViewport({ scale: scale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({
          canvasContext: canvas.getContext("2d"),
          viewport: viewport
        });
      });
    }
  }
}
